import { connect } from 'react-redux';
import * as RX from 'reactxp';
import { applyBreakpoints } from '../../utils/breakpoints';
import { mapStateToProps } from '../../utils/mapper';
import { button, colors } from '../../utils/styles';
import ExternalPopup from './external_popup';

import Action from '../../modules/svgs/action';

interface ExternalLinkProps {
  text: string;
  destination?: string;
  dispatch: (action: any) => void;
  dark?: boolean;
  locText: string;
  button?: boolean;
  isMenu?: boolean;
  window: { width: number; multiplier?: number };
  small?: boolean;
  results?: boolean;
  left?: boolean;
};

const styles = (multiplier) => ({
  buttonStyle: RX.Styles.createLinkStyle({
    backgroundColor: colors.secondary,
    borderRadius: 5 * multiplier,
    height: 60 * multiplier,
    letterSpacing: 0.4,
    marginTop: 12 * multiplier,
    padding: 18 * multiplier,
    textDecorationLine: 'none',
  }),
  link: RX.Styles.createLinkStyle({
    height: 60 * multiplier,
    letterSpacing: 0.4,
    marginTop: 18 * multiplier,
    minWidth: 300 * multiplier,
  }),
  menu: RX.Styles.createLinkStyle({
    color: colors.menuBlue,
    fontWeight: '400',
    textDecorationLine: 'none',
  }),
  small: RX.Styles.createLinkStyle({
    color: colors.primary,
    fontSize: 14 * multiplier,
    fontWeight: '400',
    letterSpacing: 0.4,
  }),
});

export class ExternalLink extends RX.Component<ExternalLinkProps, RX.Stateless> {
  constructor(props: ExternalLinkProps) {
    super(props);
  }

  public render() {
    const { window: { width, multiplier = 1 }, destination, text, small, isMenu, dark, dispatch, results } = this.props;

    return (
      <RX.View>
        <RX.Link
          url={destination ? destination : ''}
          style={[
            button,
            {
              color: dark ? colors.grey : colors.white,
              fontSize: 18 * multiplier,
              textDecorationLine: 'underline'
            },
            small ? styles(multiplier).small : this.props.button
              ? styles(multiplier).buttonStyle
              : isMenu
              ? styles(multiplier).menu
              : styles(multiplier).link,
            isMenu ? { paddingTop: 8, paddingBottom: 8 } : {},
            { height: RX.Platform.getType() === 'web' ? 60 * multiplier : 70 },
            ...applyBreakpoints(width, {
                md: {
                  color:
                    dark
                    ? colors.grey
                    : small
                    ? colors.primary
                    : this.props.isMenu
                    ? colors.menuBlue
                    : colors.white ,
                  marginBottom: 0,
                  maxWidth: results ? 276 : 300,
                  minWidth: results ? 276 : 0,
                  textAlign: this.props.left || this.props.isMenu ? 'left' : 'center',
            }})
            ]}
          { ...this.props }
         // onPress={() => dispatch({ type: 'SHOW_POPUP', children: <ExternalPopup { ...this.props }/> })}
        >
          <RX.Text>
            {text}
          </RX.Text>
        </RX.Link>
      </RX.View>
    );
  }
}

export default connect(mapStateToProps)(ExternalLink);



// WEBPACK FOOTER //
// ./src/components/external_link/index.tsx